import { useState, useEffect } from "react";
import IconSidebarCaretDown from "./icon-arrow-down.svg?react";
import LogoTvsd from "@/assets/images/tvsd_logo.svg?react";
import LogoTvsdBottom from "@/assets/images/tvsd_logo_bottom.svg?react";

type SidebarItemType = {
  label: string;
  icon?: React.ReactNode;
  iconActive?: React.ReactNode;
  activeUrl?: string[];
  isIndex?: boolean;
  onClick?: () => void;
  children?: SidebarItemType[];
};

type SidebarType = {
  title: string;
  items: SidebarItemType[];
  location: any;
  onClickLogo: () => void;
  openSidebar?: boolean;
  hasSupportChat?: boolean;
  supportChatLoading?: boolean;
  onSupportChatClick?: () => void;
};

const Sidebar = (props: SidebarType) => {
  const {
    title,
    items,
    location,
    openSidebar = true,
    onClickLogo,
  } = props;
  const [activeIndex, setActiveIndex] = useState<number>(-1);
  const [currentUrl, setCurrentUrl] = useState<string>("");
  const [openMobileSidebar, setOpenMobileSidebar] =
    useState<boolean>(openSidebar);

  const renderChildren = (children: SidebarItemType[], parentIndex: number) => {
    return (
      <ul
        className={`theme-sidebar-children ${
          activeIndex !== parentIndex && "theme-sidebar-children-hidden"
        }`}
      >
        {children.map((child: SidebarItemType, index: number) => {
          const childUrls: string[] | undefined = child.activeUrl;
          const checkIsActive: boolean =
            childUrls !== undefined
              ? childUrls.some((url: string) => {
                  return currentUrl.includes(url);
                })
              : false;
          return (
            <li
              key={`sidebar-${parentIndex}-${index}`}
              className={`${checkIsActive && "theme-sidebar-item-active"}`}
            >
              <div
                className="theme-sidebar-child-item"
                onClick={() => child.onClick && child.onClick()}
              >
                <span>{child.label}</span>
              </div>
            </li>
          );
        })}
      </ul>
    );
  };

  useEffect(() => {
    setCurrentUrl(window.location.href);
    setOpenMobileSidebar(false);
  }, [location]);

  useEffect(() => {
    setOpenMobileSidebar(openSidebar);
  }, [openSidebar]);

  return (
    <aside
      className={`theme-sidebar ${openMobileSidebar && "theme-sidebar-open"}`}
    >
      <div className="theme-sidebar-wrapper">
        <a
          href="#"
          onClick={() => {
            setActiveIndex(-1);
            onClickLogo();
          }}
          className="theme-sidebar-logo-wrapper"
        >
          <LogoTvsd />
        </a>
        <div>
          <ul className="theme-sidebar-menu">
            <li className="theme-sidebar-title">{title}</li>
            {items.map((item: SidebarItemType, index: number) => {
              const checkIsActive =
                item.activeUrl?.some((url) => currentUrl.includes(url)) ||
                (item.isIndex !== undefined &&
                  item.isIndex &&
                  window.location.href.replace("#", "") ===
                    `${window.location.origin}/`);

              return (
                <li key={`sidebar-${index}`}>
                  <button
                    className={`theme-sidebar-link" ${
                      checkIsActive ? "theme-sidebar-item-active" : ""
                    }`}
                    onClick={() => {
                      setActiveIndex(activeIndex === index ? -1 : index);
                      item.onClick();
                    }}
                  >
                    {item.icon && item.iconActive && (
                      <div className="theme-sidebar-icon">
                        {checkIsActive ? item.iconActive : item.icon}
                      </div>
                    )}
                    {item.label}
                    {item.children !== undefined &&
                      Array.isArray(item.children) &&
                      item.children.length > 0 && (
                        <span className="theme-sidebar-arrow">
                          <IconSidebarCaretDown
                            className={`theme-sidebar-arrow ${
                              index === activeIndex && "is-opened"
                            }`}
                          />
                        </span>
                      )}
                  </button>
                  {item.children !== undefined &&
                    Array.isArray(item.children) &&
                    item.children.length > 0 &&
                    renderChildren(item.children, index)}
                </li>
              );
            })}
          </ul>
        </div>

        <div className="theme-sidebar-footer">
          <div className="logo-wrapper">
            <LogoTvsdBottom />
          </div>
          <div className="content-wrapper">
            <a
              href="https://www.tvsd.ai/en/privacy-policy"
              className="color-theme-grey-200"
              target="_blank"
            >
              Privacy Policy
            </a>
            <a
              href="https://www.tvsd.ai/en/terms-of-use"
              className="color-theme-grey-200"
              target="_blank"
            >
              Terms Of Use
            </a>
            <a
              href="https://www.tvsd.ai/en/cookie-policy"
              className="color-theme-grey-200"
              target="_blank"
            >
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
